import { LockOffIcon } from './LockOffIcon';

/**
 * author: Colton Wiscombe
 * id 481E2C2A-E70D-4323-867E-5632966B9555
 * name lock-off
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-off.svg
 * tags
 * - Lock 
 */
export const NotProtectedIcon = LockOffIcon;
export default NotProtectedIcon